import { withTranslation } from "react-i18next";
import jobLogo from "../../assets/joblogo.jpg";
import "./styles.css";

const index = ({ data, key }) => {
  return (
    <div
      className="d-flex p-3 flex-column align-items-center shadow bg-white mb-3 empslide justify-content-between"
      key={key}
    >
      <img
        src={data?.logo || jobLogo}
        width="100px"
        height="100px"
        className="rounded-circle"
        style={{ border: "1px solid rgb(0,0,0,0.2)", padding: "2px" }}
        alt={data?.name}
      />
      <>
        <h6 className="text-info mt-2 mb-0 text-center">{data?.name}</h6>
        <p className="tag-line">{data?.tagLine}</p>
      </>
    </div>
  );
};
export default withTranslation()(index);
